import React, { useState } from "react";
import Minus from "images/Minus.svg";
import Plus from "images/Plus.svg";
import NcImage from "images/FAQ.png";

interface SectionProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

const Section: React.FC<SectionProps> = ({
  title,
  children,
  isOpen,
  onToggle,
}) => {
  return (
    <div className=" my-4 rounded-xl">
      <button
        onClick={onToggle}
        className="flex justify-between w-full space-x-4  py-6 text-left items-center"
      >
        <span className="text-lg font-semibold leading-7 text-left text-[#121212]">
          {title}
        </span>
        <span>
          {isOpen ? (
            <svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.75287 20.0282L13.7224 14.0587C14.0635 13.7176 14.1488 13.1206 13.7224 12.6942C13.3813 12.3531 12.7843 12.2678 12.3579 12.6942L8.0087 17.0435L7.92342 1.09624C7.92342 0.584567 7.49703 0.158171 6.98535 0.158171C6.47368 0.158171 6.04728 0.584567 6.04728 1.09624L6.04728 17.1287L1.69804 12.7795C1.35692 12.4384 0.759969 12.3531 0.333573 12.7795C-0.00754342 13.1206 -0.092824 13.7176 0.333572 14.144L6.30312 20.1135C6.72951 20.3693 7.41175 20.3693 7.75287 20.0282Z" fill="#1F242E" />
            </svg>

          ) : (
            <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.7086 6.57299L14.6784 0.542841C14.3166 0.181032 13.7136 0.181032 13.3518 0.542841C12.99 0.90465 12.99 1.50767 13.3518 1.86947L17.6935 6.21118H1.89451C1.4121 6.33179 0.929688 6.69359 0.929688 7.29661C0.929688 7.77902 1.2915 8.26143 1.89451 8.26143H17.8141L13.4724 12.6031C13.1106 12.965 13.1106 13.568 13.4724 13.9298C13.8342 14.2916 14.4372 14.2916 14.799 13.9298L20.8292 7.89962C21.0704 7.53782 21.0704 6.9348 20.7086 6.57299Z" fill="#AD0419" />
            </svg>

          )}
        </span>
      </button>
      {isOpen && <div className="px-4 py-2">{children}</div>}
    </div>
  );
};

const FAQ: React.FC = () => {
  const [openSectionIndex, setOpenSectionIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenSectionIndex(openSectionIndex === index ? null : index);
  };
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 items-center">
      <div className="flex max-w-lg flex-col space-y-10 justify-center mb-16">
        <img className="w-full" src={NcImage} alt="" />
      </div>

      <div className="mt-12">
        <h2 className="text-4xl font-semibold">Explaining Common<br /> <span className="text-primary-100">Car Rental Concerns</span></h2>
        <Section
          title="What is the minimum age requirement for renting?"
          isOpen={openSectionIndex === 1}
          onToggle={() => handleToggle(1)}
        >
          <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
            You must be 18 or older with a valid drivers license to rent.
          </span>
        </Section>

        <Section
          title="Is there a security deposit needed for rentals?"
          isOpen={openSectionIndex === 3}
          onToggle={() => handleToggle(3)}
        >
          <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
            There’s a security deposit of $175, the security deposit is for gas,
            smoking and cleaning. If any of these things are violated, you’ll be
            charged.
          </span>
        </Section>
        <Section
          title=" Is there a minimum rental duration?"
          isOpen={openSectionIndex === 4}
          onToggle={() => handleToggle(4)}
        >
          <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
            Yes, our minimum rental period is 24 hours.
          </span>
        </Section>
        <Section
          title="Do I need my own auto insurance to rent?"
          isOpen={openSectionIndex === 5}
          onToggle={() => handleToggle(5)}
        >
          <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
            You do not need your own insurance. It is a requirement to
            purchase insurance.
          </span>
        </Section>
      </div>
    </div>
  );
};

export default FAQ;